module.exports = __webpack_public_path__ + "static/0057-3d9ad0589dc734f81aa94e2a17ba0212.png";